/**
 * Provides a localized month name, either long or short
 * @param month
 * @param long
 * @param language "sl" | "en"
 */
export function getMonthName(month, long, language) {
    var date = new Date(0);
    date.setMonth(month);
    var locale = language == "sl" ? "sl-SI" : "en-UK";
    return new Intl.DateTimeFormat(locale, { month: long ? "long" : "short" }).format(date);
}
